import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-country-coverage',
  templateUrl: './country-coverage.component.html',
  styleUrls: ['./country-coverage.component.css']
})
export class CountryCoverageComponent implements OnInit {

  activeTab = 'Asia';
  filteredCountryFlags = [];
  allCountryFlags: any;
  countryListPaymentType = 'local_payment';
  countryFlagBaseURL = 'https://singxco.github.io/static-data/images/flags/4x3/';

  constructor(private http: HttpClient) {

   }

  ngOnInit(): void {

  this.loadCountryFlags();
  }

  loadCountryFlags() {
    this.http.get('./assets/country-coverage.json').subscribe(flags => {
      console.log('flags', flags);
      this.allCountryFlags = flags;
      this.selectTab('Asia');
    })
  }
  selectTab(tab) {
    this.activeTab = tab;
    const selectedAreaFlags = this.allCountryFlags[tab];
    console.log('selectedAreaFlags', selectedAreaFlags);
    this.filteredCountryFlags = selectedAreaFlags;
  }

  onPaymentTypeSelect() {
    if (this.countryListPaymentType == 'local_payment')
      this.selectTab('Asia');
    else
      this.selectTab('Asia');
  }

}